import { useState } from 'react';
import useQueryAsState from 'hooks/useQueryAsState';
import useApiUser from 'service/apicataleg/useApiUser';

const useClientOrders = () => {
  const [params, updateQuery] = useQueryAsState();

  const { year = new Date().getFullYear(), npes = '', month = -1 } = params;
  const [npeInput, setNpeInput] = useState('');
  const [queryData, setQueryData] = useState({ orders: [], from: '', to: '' });

  const { api } = useApiUser();
  const searchOrders = async () => {
    api.order
      .getOrders(year, month, npes)
      .then((res) => {
        setQueryData(res);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const setSelYear = (newYear) => {
    const { year: oldYear, ...rest } = params;
    updateQuery({ year: newYear, ...rest });
  };

  const npeStrToArray = (strNpes) => {
    if (!strNpes) return [];

    const res = strNpes
      .split(',')
      .map((x) => parseInt(x, 10))
      .filter((x) => !Number.isNaN(x));
    return res;
  };

  const arrayToStrNpe = (arr) => {
    return arr.join(',');
  };

  const addNpe = (npe) => {
    const numericNpe = parseInt(npe, 10);
    const current = npeStrToArray(npes);
    const { npes: prev, ...rest } = params;
    if (prev === '') {
      updateQuery({ npes: `${npe}`, ...rest });
    } else if (!current.some((x) => x === numericNpe)) {
      updateQuery({ npes: `${current},${npe}`, ...rest });
    }
  };

  const removeNpe = (npe) => {
    const current = npeStrToArray(npes);
    const { npes: prev, ...rest } = params;

    if (current.some((x) => x === npe)) {
      const newNpes = current.filter((x) => x !== npe || Number.isNaN(x));
      updateQuery({ npes: arrayToStrNpe(newNpes), ...rest });
    }
  };

  const setSelMonth = (newMonth) => {
    const { month: oldMonth, ...rest } = params;
    updateQuery({ month: newMonth, ...rest });
  };

  return {
    year: parseInt(year, 10),
    month: parseInt(year, 10),
    npes: npeStrToArray(npes),
    addNpe,
    removeNpe,
    setSelYear,
    setSelMonth,
    searchOrders,
    npeInput,
    setNpeInput,
    ordersQuery: queryData,
  };
};

export default useClientOrders;
